/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgentListResponse } from '../models/agent-list-response';
import { getAllAgents } from '../fn/user/get-all-agents';
import { GetAllAgents$Params } from '../fn/user/get-all-agents';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllAgents()` */
  static readonly GetAllAgentsPath = '/users/agents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAgents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAgents$Response(params?: GetAllAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentListResponse>>> {
    return getAllAgents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAgents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAgents(params?: GetAllAgents$Params, context?: HttpContext): Observable<Array<AgentListResponse>> {
    return this.getAllAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgentListResponse>>): Array<AgentListResponse> => r.body)
    );
  }

}
